import { validateRut } from './rut';

export function rutValidator(_, value) {
  if (!value) {
    return Promise.reject(new Error('Campo RUT es requerido'));
  }

  if (value && validateRut(value)) {
    return Promise.resolve();
  }

  return Promise.reject(new Error('RUT inválido'));
}



export default { rutValidator };
